// extracted by mini-css-extract-plugin
export var bg_second = "screen-module--bg_second--iCSI+";
export var bg_first = "screen-module--bg_first--g7LMT";
export var screen = "screen-module--screen--xq7Sc";
export var screen_first = "screen-module--screen_first--SHr0z";
export var firstScreenMainContent = "screen-module--firstScreenMainContent--kf+zG";
export var column2 = "screen-module--column2--JE+rE";
export var left = "screen-module--left--j-OUx";
export var right = "screen-module--right--arVCl";
export var otherScreenEven = "screen-module--otherScreenEven--xY28I";
export var otherScreenOdd = "screen-module--otherScreenOdd--B9cso";
export var row = "screen-module--row--pxURf";